import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-[56px] h-[56px]" }
const _hoisted_2 = {
  key: 1,
  class: "w-[50px] h-[50px] flex items-center justify-center !bg-gradient-to-b from-primary100 to-primary700 rounded-full"
}
const _hoisted_3 = { class: "text-lg text-white" }
const _hoisted_4 = { class: "ml-1" }
const _hoisted_5 = { class: "text-[13px] text-textGray500 font-semibold tracking-wide" }

import { ref } from 'vue';
import Avatar from '../Avatar/BaseAvatar.vue';
import { siteUrlApiUpload } from '@/main'
interface Props {
    srcAvatr: string
    firstName: any
    lastName: any
    phone: any
    styleBoxAvatar?: string
    colBox?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseInfoUser',
  props: {
    srcAvatr: null,
    firstName: null,
    lastName: null,
    phone: null,
    styleBoxAvatar: null,
    colBox: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    srcAvatr: string
    firstName: any
    lastName: any
    phone: any
    styleBoxAvatar?: string
    colBox?: boolean
};


const ShowAvatar = ref<boolean>(false)
const styleAvatar = ref<any>(null)
const img = ref()
const src = ref<any>()
if (props.styleBoxAvatar) {
    styleAvatar.value = props.styleBoxAvatar
}
if (props.srcAvatr == '' || props.srcAvatr == null) {
    ShowAvatar.value = false
} else {
    ShowAvatar.value = true
    src.value = siteUrlApiUpload + props.srcAvatr
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-full h-[58] flex items-center gap-4", { 'flex-col gap-y-2 justify-center my-4': __props.colBox }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (ShowAvatar.value)
        ? (_openBlock(), _createBlock(Avatar, {
            key: 0,
            "img-url": src.value,
            "img-alt": __props.firstName + '-' + __props.lastName,
            "style-box": styleAvatar.value,
            lastName: __props.lastName
          }, null, 8, ["img-url", "img-alt", "style-box", "lastName"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(__props.lastName[0]), 1)
          ]))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["w-full flex flex-col gap-y-1", { 'items-center': __props.colBox }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["w-full flex items-center text-[13px] text-textColor300 font-extrabold font-yekan-700", { 'justify-center': __props.colBox }])
      }, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.firstName) + " " + _toDisplayString(__props.lastName), 1)
      ], 2),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("bdi", null, _toDisplayString(__props.phone), 1)
      ])
    ], 2)
  ], 2))
}
}

})